import { extractErrorMessage } from "utils/extractErrorMessage";

import type { AccrualsRepositoryT } from "../../domain/ports/accruals.repository";
import type {
  AccrualRowT,
  AccrualRowWithIndexT,
} from "../../domain/types/accrual.types";
import type { AccrualsApiT, AccrualsMapperT } from "../types/accruals.types";

type AccrualsRepositoryParamsT = {
  accrualsApi: AccrualsApiT;
  accrualsMapper: AccrualsMapperT;
};

export const createAccrualsRepository = ({
  accrualsApi,
  accrualsMapper,
}: AccrualsRepositoryParamsT): AccrualsRepositoryT => ({
  load: async (rows: AccrualRowWithIndexT[], colaboraInstanceId: string) => {
    try {
      const dto = accrualsMapper.toRequestDto(rows);

      const response = await accrualsApi.load(dto, colaboraInstanceId);

      if (response.status !== 200 && response.status !== 201) {
        throw response.error;
      }

      return accrualsMapper.toDomain(response.data);
    } catch (error) {
      const message = extractErrorMessage(
        error,
        "Ocurrió un error al cargar los balances",
      );

      throw new Error(message);
    }
  },
  create: async (rows: AccrualRowT[], colaboraInstanceId: string) => {
    try {
      const dto = accrualsMapper.toCreateRequestDto(rows);

      const response = await accrualsApi.create(dto, colaboraInstanceId);

      if (response.status !== 200 && response.status !== 201) {
        throw response.error;
      }

      return accrualsMapper.createDtoToDomain(response.data);
    } catch (error) {
      const message = extractErrorMessage(
        error,
        "Ocurrió un error al crear el saldo del colaborador",
      );

      throw new Error(message);
    }
  },
});
